export default (imageFile, MAX_WIDTH, MAX_HEIGHT) => {

  return new Promise( (resolve, reject) => {

    var reader = new FileReader();
    reader.onerror = reject;
    reader.onload = (e) => {
      var img = document.createElement("img");
      img.onerror = reject;
      img.onload = (event) => {

        var width = img.width;
        var height = img.height;

        // Change the resizing logic
        if (width > height) {
          if (width > MAX_WIDTH) {
            height = height * (MAX_WIDTH / width);
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width = width * (MAX_HEIGHT / height);
            height = MAX_HEIGHT;
          }
        }

        // Dynamically create a canvas element
        var canvas = document.createElement("canvas");

        // var canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");

        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);

        // Show resized image in preview element
        var dataurl = canvas.toDataURL(imageFile.type);

        resolve(dataurl)
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(imageFile);

  })
 
}